import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { filter, map, Observable, of, take, tap } from 'rxjs';
import { FeatureFlagService } from './feature-flag.service';
import { navigationItems, navigationFixedItems } from '@app/main/navigation-items';
import { UserService } from '@app/admin-station/work-center/user/services/user.service';
import { UserDTO } from '@app/shared/interfaces/user';
import { PermissionsService } from '../permissions/permissions.service';

@Injectable()
export class FeatureFlagCanActivate implements CanActivate {
  constructor(
    private _featureFlagService: FeatureFlagService,
    private _permissionService: PermissionsService,
    private _router: Router,
    private _userService: UserService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const {
      data: { featureFlagModule },
    } = route;
    const items  = navigationFixedItems.concat(navigationItems);
    const permission = items.find((v) => v.routerLink === route.routeConfig.path);

    return this._userService.userLoginData$.pipe(
      filter(Boolean),
      take(1),
      map((userData: UserDTO) => {
        // The menu item's key, or route.data.permissionKey for internal views (e.g. a single record)
        // that have no menu item. No key = open to any signed-in user, as before.
        const permissionKey = permission?.permissionKey || route.data?.permissionKey;

        // Same rule as the menu (*visibility -> PermissionsService.evaluate), so a page is never
        // blocked for someone who can see its menu item.
        if (permissionKey && !this._permissionService.evaluateRoutePermission(userData, permissionKey)) {
          return this._router.createUrlTree(['/forbidden']);
        }

        return (featureFlagModule ? this._featureFlagService.evaluate(featureFlagModule) : true);
      })
    );
  }
}
